import { createSlice /*PayloadAction*/ } from "@reduxjs/toolkit";
import { RootState } from "../app/store";

export interface userState {
  currentUser: object | null | any;
  logingUser: boolean;
  resettingPassword: boolean;
  userPermissions: any;

  // login details
  username: string;
  password: string;
  otp: string;

  // reset password details
  newPassword: string;
}

const initialState: userState = {
  currentUser: null,
  logingUser: false,
  username: "",
  password: "",
  otp: "",
  newPassword: "",
  resettingPassword: false,
  userPermissions: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setLoginUser: (state, action) => {
      state.logingUser = action.payload;
    },
    setResettingPassword: (state, action) => {
      state.resettingPassword = action.payload;
    },
    setUser: (state, action) => {
      state.currentUser = action.payload;
    },
    setLoggedInUser: (state, action) => {
      localStorage.setItem("currentAdminUser", JSON.stringify(action.payload));
    },
    setUserPermission: (state, action) => {
      state.userPermissions = action.payload?.concat([
        "other-settings",
        "verify-hostel-allocation",
      ]);
    },
    restoreCurrentUser: (state, action) => {
      state.currentUser = action.payload;
    },
    getAccountDetails: (state, action) => ({
      ...state,
      [action?.payload?.name]: action?.payload?.value,
    }),

    logoutUser: (state, action) => {
      localStorage.clear();
    },
  },
});

export const {
  setUser,
  setLoginUser,
  restoreCurrentUser,
  getAccountDetails,
  logoutUser,
  setResettingPassword,
  setUserPermission,
  setLoggedInUser,
} = userSlice.actions;
export const selectUser = (state: RootState) => state.user;

export default userSlice.reducer;
